import { render, staticRenderFns } from "./WizardRoot.vue?vue&type=template&id=5e4ba2d1"
import script from "./WizardRoot.vue?vue&type=script&lang=ts"
export * from "./WizardRoot.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports